import { superAxios } from "./superAxios";
var OcelotService="Default";

//获取新闻所有分类
export const GetListNewsClass = async (params: any) => {
     const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).get({
    url: "app/NewsContentFrontEnd/GetListNewsClass",
    params
  });
   const shop= res.data
  return shop;
};


/// <summary>
/// 根据FParentId查询新闻 
/// </summary>

export const GetNewsFParentIdContents = async (params: any) => {
     const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/NewsContentFrontEnd/GetNewsFParentIdContents",
    params
  });
   const shop= res.data
  return shop;
};

/// <summary>
/// 根据ID查询新闻（更新）
/// </summary>
export const GetNewsContents = async (params: any) => {
     const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/NewsContentFrontEnd/GetNewsContents",
    params
  });
  const shop= res.data
  return shop;
};

//获取新闻列表
export const GetListNewsContents = async (params: any) => {
     const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).get({
    url: "app/NewsContentFrontEnd/GetListNewsContents",
    params
  });
   const shop= res.data
  return shop;
};
//留言板
export const AddMessageManage = async (params: any) => {
    var res = await (await superAxios.useWebAPI(OcelotService)).post({
        url: "app/NewsContentFrontEnd/AddMessageManage",
        params
    })
    return res.data;
}

 
